import React from 'react';
import './HomeService.css';
import serviceImg from '../../../assets/Home/service.jpg';
import { Link } from 'react-router-dom';

/* ── Local SVG Icon ─────────────────────────────────── */
const IconArrow = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);

/* ── Services Data ──────────────────────────────────── */
const SERVICES = [
  { 
    no: '01', 
    tag: 'Flagship Advisory',   
    title: 'New Medical College Establishment',          
    sub: 'From Initial Planning to Institutional Readiness',         
    desc: 'Structured professional advisory covering preliminary project planning, proposed MBBS intake, academic and hospital requirement assessment, infrastructure planning, faculty planning, and statutory readiness.', 
    link: '/services/new-medical-college-establishment',
    image: serviceImg
  },
  { 
    no: '02', 
    tag: 'Capacity Growth',     
    title: 'MBBS Seat Expansion',                        
    sub: 'Supporting the Next Stage of Institutional Growth',         
    desc: 'Professional advisory, assessment, documentation, and readiness support for eligible existing Medical Colleges planning to increase their MBBS admission capacity.',                                        
    link: '/services/mbbs-seat-expansion' 
  },
  { 
    no: '03', 
    tag: 'Postgraduate Scope',  
    title: 'PG (MD/MS) Course & Seat Expansion',         
    sub: 'Advancing Postgraduate Medical Education',                  
    desc: 'Professional advisory and documentation support for institutions planning to introduce new PG (MD/MS) courses or increase seats in existing postgraduate programmes.',                               
    link: '/services/pg-course-seat-expansion' 
  },
  { 
    no: '04', 
    tag: 'Hospital & Clinical', 
    title: 'Institutional & Teaching Hospital Compliance',
    sub: 'Strengthening Academic & Clinical Preparedness',            
    desc: 'Structured support for reviewing key academic, manpower, hospital, clinical, ICU/OT, diagnostic, and infrastructural requirements of Medical Colleges and Teaching Hospitals.',                  
    link: '/services/institutional-compliance' 
  },
  { 
    no: '05', 
    tag: 'Gap Analysis',        
    title: 'Documentation & Institutional Readiness',     
    sub: 'Structured Documentation. Better Preparedness.',            
    desc: 'Professional support for institutional documentation, department-wise readiness, faculty documentation, hospital statistics, gap identification, and corrective planning.',                          
    link: '/services/documentation-readiness' 
  },
  { 
    no: '06', 
    tag: 'Academic Manpower',   
    title: 'Medical Faculty Recruitment',                 
    sub: 'Building the Academic Strength of Medical Institutions',    
    desc: 'Permanent & Full-Time Medical Faculty Recruitment across Pre-Clinical, Para-Clinical, and Clinical departments according to Department-wise and Designation-wise requirements.',                   
    link: '/services/medical-faculty-recruitment' 
  },
];

const HomeService = () => {
  const flagship = SERVICES[0];
  const otherServices紧 = SERVICES.slice(1);

  return (
    <section id="services" className="home-services-section">
      {/* Background large decorative typography */}
      <div className="hmsvc-decor" aria-hidden="true">SERVICES</div>

      <div className="hmsvc-container">
        {/* Section Header */}
        <div className="hmsvc-head center">
          <div className="hmsvc-eyebrow center">
            <span className="hmsvc-eyebrow-line"></span>
            Our Core Expertise
            <span className="hmsvc-eyebrow-line"></span>
          </div>
          <h2 className="hmsvc-h2">Integrated Solutions for Medical Education Institutions</h2>
          <p className="hmsvc-section-desc">
            Comprehensive institutional advisory and medical faculty solutions designed for promoters, leadership teams, and medical colleges.
          </p>
        </div>

        {/* Services Layout (1 Flagship Featured + 5 Compact Rows) */}
        <div className="hmsvc-layout">
          {/* Flagship Card (01) */}
          <a href={flagship.link} className="hmsvc-featured">
            <div className="hmsvc-featured-img">
              <img src={flagship.image} alt={flagship.title} loading="lazy" />
              <div className="hmsvc-featured-img-overlay"></div>
            </div>
            <div className="hmsvc-featured-body">
              <span className="hmsvc-tag">{flagship.tag}</span>
              <h3 className="hmsvc-featured-title">{flagship.title}</h3>
              <p className="hmsvc-featured-sub">{flagship.sub}</p>
              <p className="hmsvc-featured-desc">{flagship.desc}</p>
              <div className="hmsvc-featured-link">
                <span>Explore Service</span>
                <IconArrow />
              </div>
            </div>
          </a>

          {/* Compact List (02 to 06) */}
          <div className="hmsvc-list">
            {otherServices紧.map((item, idx) => (
              <a key={idx} href={item.link} className="hmsvc-row">
                <div className="hmsvc-row-num">{item.no}</div>
                <div className="hmsvc-row-body">
                  <span className="hmsvc-row-tag">{item.tag}</span>
                  <h4 className="hmsvc-row-title">{item.title}</h4>
                  <p className="hmsvc-row-sub">{item.sub}</p>
                </div>
                <div className="hmsvc-row-arrow">
                  <IconArrow />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeService;